export default __webpack_public_path__ + "static/media/havet.60786abb.jpg";